export const REFER_AND_EARNS = 'REFER_AND_EARNS';
export const REFER_AND_EARNS_SUCCESS = 'REFER_AND_EARNS_SUCCESS';
export const REFER_AND_EARNS_FAILURE = 'REFER_AND_EARNS_FAILURE';
